import { Divider as AntDivider, DividerProps as AntDividerProps } from 'antd';

interface DividerProps extends AntDividerProps {}

const Divider: React.FC<DividerProps> = (props) => <AntDivider {...props} />;
export default Divider;
